import {ExtraOptions} from "./ShopTable";
import {useContext} from "react";
import {EditContext} from "../../../misc/scroller/EditProvider";
import {SelectFilterForCol} from "../../../misc/SelectFilterForCol";
import {editCellPadding} from "../../../misc/scroller/TableEditCell";

export function Checkbox2Col<T>(name: string, key: keyof T, opts?: {
    disabled?: (input: T) => boolean
}) {
    return {
        name: name,
        key: key as any,
        width: 80,
        render: (data: T) => {
            return <CheckboxEl
                checked={!!data[key]}
                disabled={opts?.disabled?.(data)}
                onChange={checked => Object.assign({}, data, {
                    [key]: checked
                })} />
        },
        editable: {
            type: "checkbox",
        },
        editKey: key,
        sort: (a: T, b: T) => {
            // @ts-ignore
            return a[key] === b[key] ? 0 : a[key] ? 1 : -1
        },
        filter: (row: T, input: string) => {

            const str = input.toLowerCase().trim();

            if(str === "y" || str === "ye" || str === "yes") {
                return (row[key] as any as boolean) === true;
            } else if(str === "n" || str === "no") {
                return (row[key] as any as boolean) !== true;
            }

            return true;
        },
        renderFilter: (props: any) => {
            return <SelectFilterForCol value={props.value} onChange={props.onChange} list={yesNoList} />
        }
    } as any;
}

const yesNoList = ["Yes", "No"];

export function CheckboxEl<T>(props: {
    style?: any;
    checked: boolean;
    disabled?: boolean;
    onChange(checked: boolean): T
}) {
    const edit = useContext(EditContext);

    return (
        <div style={Object.assign({display: "flex", justifyContent: "center",
            height: 20,
            marginLeft: -editCellPadding.left,
            marginRight: -editCellPadding.right,
            marginTop: -editCellPadding.top - 2,
            marginBottom: -editCellPadding.bottom - 2,
        }, props.style)}>
            <input disabled={props.disabled} type="checkbox" checked={props.checked} onChange={e => {
                edit.update(props.onChange(e.currentTarget.checked))
            }} />
        </div>
    )
}

export function StringCol<T>(name: string, key: keyof T, misc?: ExtraOptions<T>) {
    return {
        name: name,
        key: key,
        buildFilter: (str: string) => {
            if(str === "") return () => true;
            return (obj: T) => (obj[key] as any as string).indexOf(str) !== -1;
        },
        extra: misc,
    }
}

export function NumberCol<T>(name: string, key: keyof T, misc?: ExtraOptions<T>) {
    return {
        name: name,
        key: key,
        buildFilter: (str: string) => {
            if(str === "") return () => true;

            const value = parseInt(str);
            return (obj: T) => parseInt(obj[key] as any as string) === value;
        },
        formatUpdate: (str: string) => {
            return parseInt(str)
        },
        extra: misc,
    }
}